import React from 'react';
import './SuccessModal.css';

const SuccessModal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleGoToMainWebsite = () => {
    // You can customize this URL to redirect to your main website
    window.location.reload(); 
    onClose();
  };

  return (
    <div 
      className="modal fade successModal modal-cx" 
      style={{ display: 'block' }}
      tabIndex="-1" 
      role="dialog" 
      aria-labelledby="successModalLabel" 
      aria-hidden="false"
      onClick={handleBackdropClick}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <div className="icon-image-modal-successfully">
              <img 
                src="/documents/d/global/successmodalicon" 
                alt="Success"
                onError={(e) => {
                  // Fallback if image doesn't load
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="success-icon-fallback">✓</div>';
                }}
              />  
            </div>
            <div className="content-modal">
              <p className="mb-0 heading-modal">
                {title || 'Your form has been submitted successfully!'}
              </p>
              <p className="content-box-modal">
                {message || 'Thank you for your submission. We have received your information and will contact you soon.'}
              </p>
            </div>
            <button 
              type="button" 
              className="btn primary-button bold" 
              onClick={handleGoToMainWebsite}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
